import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  message,
  Popconfirm,
  Row,
  Switch,
  Table,
  Tag,
} from "antd";
import { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { CoreResource, t } from "shared/plugins/localization";
import {
  getOrderTransferPaymentSettingAPI,
  updateOrderTransferPaymentSettingAPI,
} from "states/payment-setting/payment-setting.api";
import {
  OrderTransferPaymentBankAccountModel,
  OrderTransferPaymentSettingModel,
} from "states/payment-setting/payment-setting.models";

export interface IPaymentTransferSettingProps {}

export function PaymentTransferSetting(props: IPaymentTransferSettingProps) {
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState<OrderTransferPaymentSettingModel>({
    isActive: false,
    bankAccounts: [],
  });

  const onSubmit = async () => {
    setLoading(true);
    try {
      await updateOrderTransferPaymentSettingAPI(model);
      message.success(t(CoreResource, "UpdateDataSuccessfully"));
    } catch (error) {
      message.error(
        error?.response?.data?.error?.message ??
          t(CoreResource, "DefaultErrorMessage")
      );
    }
    setLoading(false);
  };

  const bankAccountColumns: ColumnsType<OrderTransferPaymentBankAccountModel> =
    [
      {
        title: "Ngân hàng",
        dataIndex: "bankName",
        key: "bankName",

        render: (bankName, item) => (
          <Input
            value={bankName}
            onChange={(e) => {
              item.bankName = e.target.value;
              setModel({ ...model });
            }}
          />
        ),
      },
      {
        title: "Tên tài khoản",
        dataIndex: "accountName",
        key: "accountName",

        render: (accountName, item) => (
          <Input
            value={accountName}
            onChange={(e) => {
              item.accountName = e.target.value;
              setModel({ ...model });
            }}
          />
        ),
      },
      {
        title: "Số tài khoản",
        dataIndex: "accountNumber",
        key: "accountNumber",

        render: (accountNumber, item) => (
          <Input
            value={accountNumber}
            onChange={(e) => {
              item.accountNumber = e.target.value;
              setModel({ ...model });
            }}
          />
        ),
      },
      {
        title: "Trạng thái",
        dataIndex: "isActive",
        key: "isActive",

        render: (isActive: boolean, item) => (
          <Switch
            checked={isActive}
            onChange={(e) => {
              item.isActive = e;
              setModel({ ...model });
            }}
          ></Switch>
        ),
      },
      {
        title: "",
        width: "100px",
        render: (attribute, item, index) => (
          <Popconfirm
            title={t(CoreResource, "QuestionRemove")}
            onConfirm={() => {
              model.bankAccounts.splice(index, 1);
              setModel({
                ...model,
                bankAccounts: [...model.bankAccounts],
              });
            }}
            okText="Có"
            cancelText="Không"
          >
            <Button danger icon={<DeleteOutlined />} />
          </Popconfirm>
        ),
      },
    ];

  useEffect(() => {
    getOrderTransferPaymentSettingAPI().then((res) => {
      setModel(res.data);
    });
  }, []);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Button
          loading={loading}
          disabled={loading}
          onClick={onSubmit}
          type="primary"
        >
          Lưu
        </Button>
      </Col>
      <Col span={24} xxl={24}>
        <Card title="Thanh toán COD">
          <Button
            className="mb-4"
            onClick={() => {
              model.bankAccounts.push({
                isActive: true,
              } as OrderTransferPaymentBankAccountModel);
              setModel({ ...model, bankAccounts: [...model.bankAccounts] });
            }}
            icon={<PlusOutlined />}
          >
            Thêm tài khoản
          </Button>
          <Table
            bordered
            className="mb-4"
            columns={bankAccountColumns}
            pagination={false}
            dataSource={model.bankAccounts ?? []}
            size="small"
          />
          <Input.Group className="mb-4">
            <Checkbox
              checked={model.isActive}
              onChange={(e) => {
                setModel({ ...model, isActive: e.target.checked });
              }}
            >
              Kích hoạt
            </Checkbox>
          </Input.Group>
        </Card>
      </Col>
    </Row>
  );
}
